import { format, startOfMonth } from "date-fns";

import { dateFromDateUrl } from "src/calendar/utils";

export function getProductSalesMonth(date: string | undefined): string {
  const viewDate = date ? dateFromDateUrl(date) : startOfMonth(new Date());

  return format(viewDate, "yyyy-MM");
}
